import { render, staticRenderFns } from "./BotEditor.vue?vue&type=template&id=143fbac8&"
import script from "./BotEditor.vue?vue&type=script&lang=js&"
export * from "./BotEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports